import React from 'react';
import GruShell from '../../components/gru/GruShell';
import DashboardStatistiche from './components/DashboardStatistiche';

// /gru-statistiche — analisi degli interventi per gru, reparto, anno, articolo e causa
const GruStatistichePage = () => (
  <GruShell indietroA="/gru-inventory">
    <DashboardStatistiche />
  </GruShell>
);

export default GruStatistichePage;
